import Calendar from "./Calendar";
import Slider from "./Slider";
import MobileMenu from "./MobileMenu";
import AjaxForm from "./AjaxForm";
import MonthField from "./MonthField";
import Modal from "./Modal";
import PricingTabs from "./PricingTabs";

export default {
    init: function () {
        MobileMenu.init();
        Slider.init();
        Calendar.init();
        AjaxForm.init();
        MonthField.init();
        Modal.init();
        PricingTabs.init();
        //this.runSliders();
        //this.markOpenedCategories();
        // this.menuToggle();
        //this.sidebarToggle();
        //this.sidebarMenuTogglers();
        // this.aos();
        // this.waterize();
        // this.loader();
        //this.markCurrentSidebarCategory();
    },

    // markCurrentSidebarCategory: function () {
    //     const elem = $(".current-cat");
    //     if (elem.length) {
    //         elem.parents("li").addClass("is-opened");
    //     }
    // },

    // runSliders: function () {},

    // sidebarMenuTogglers: function () {
    //     $(".widget_product_categories")
    //         .find(".cat-parent")
    //         .each(function () {
    //             const element = $(this);
    //             const link = element.find("a").first();
    //             link.after('<span class="cnt-menu-toggle"></span>');
    //         });

    //     $(document).on("click", ".cnt-menu-toggle", function () {
    //         const element = $(this);
    //         element.closest(".cat-parent").toggleClass("is-opened");
    //     });

    //     if ($(window).width() > 1199) {
    //         $(".current-cat-parent").addClass("is-opened");
    //     }
    // },

    // loader: function () {
    //     window.addEventListener("beforeunload", function (event) {
    //         $(".cnt-loader").css("display", "flex");
    //     });
    // },

    // waterize: function () {
    //     $(".page-heading").ripples({
    //         resolution: 256,
    //         perturbance: 0.005,
    //     });
    // },

    // aos: function () {
    //     AOS.init();
    //     setTimeout(() => {
    //         AOS.refresh();
    //     }, 500);
    // },

    // sidebarMenuTogglers: function () {
    //     $(".widget_product_categories")
    //         .find(".cat-parent")
    //         .each(function () {
    //             const element = $(this);
    //             const link = element.find("a").first();
    //             link.after('<span class="cnt-menu-toggle"></span>');
    //         });

    //     $(document).on("click", ".cnt-menu-toggle", function () {
    //         const element = $(this);
    //         element.closest(".cat-parent").toggleClass("is-opened");
    //     });

    //     if ($(window).width() > 1199) {
    //         $(".current-cat-parent").addClass("is-opened");
    //     }
    // },

    // markOpenedCategories: function () {
    //     var currentCat = $(".current-cat");
    //     currentCat.closest(".children").show();
    //     var parent = currentCat.closest(".current-cat-parent");
    //     parent.closest(".children").show();
    // },

    // menuToggle: function () {
    //     $(document).on("click", "[data-menu_toggle]", () => {
    //         $("body").toggleClass("menu-opened");
    //     });
    // },

    // sidebarToggle: function () {
    //     $(document).on("click", "[data-sidebar_toggle]", () => {
    //         $("body").toggleClass("sidebar-opened");
    //     });

    //     $(document).on("click", "[data-close_sidebar]", () => {
    //         $("body").removeClass("sidebar-opened");
    //     });
    // },
};
